import { queryCompanyStb, syncLogs } from '@/services/company';

export default {
  namespace: 'CompanyList_CompanyDevicesList_stb',

  state: {
    data: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { status, data } = yield call(queryCompanyStb, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: data.meta.per_page,
              current: data.meta.current_page,
            },
          },
        });
      }
    },
    // 同步日志接口
    *getLogs({ payload, callback }, { call, put }) {
      const { status, data } = yield call(syncLogs, payload);

      if (status === 200) {
        if (callback) callback(data, status);
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
